import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './index.css';
import './i18n'; 
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import { bootstrapAcademicYearFromServer } from './utils/academicYearContext';

const container = document.getElementById('root');
const root = createRoot(container); // Create root container

// Kick off a non-blocking bootstrap of the academic year context.
// If it fails or returns null, UI can still proceed and prompt later if needed.
try {
  const token = localStorage.getItem('accessToken') || localStorage.getItem('token');
  if (token) {
    bootstrapAcademicYearFromServer();
  }
} catch {}

// Re-resolve after signing in.
//
// The bootstrap above only runs when a token already exists, so on a FRESH
// login it has already been skipped by the time credentials arrive. Without
// this the new session inherits whatever year was left in localStorage — the
// previous user's, or a stale one from before the school rolled over — and
// every scoped request then carries it in X-Academic-Year-Id.
//
// That was the visible fault: School Settings asked the server and showed the
// right year, while teacher and parent pages sent the stored one and showed
// the previous session's data.
try {
  window.addEventListener('app:auth:changed', () => {
    const t = localStorage.getItem('accessToken') || localStorage.getItem('token');
    if (t) bootstrapAcademicYearFromServer();
  });
} catch {}

root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );

// Offline app shell + offline printing. New deployments are surfaced to the user
// via UpdateAvailableSnackbar rather than being activated silently, so a cached
// bundle can never hide a fresh deploy.
serviceWorkerRegistration.register();